import {Component, h} from "preact";
import styles from './style.module.scss';
import {Product} from "../../models/product";
import {connect} from "redux-zero/preact";
import ProductItem from "../product-item";
import actions from "../../store/actions";
import {QueryState} from "../../models/query";
import {i18nService} from "../../services/i18n-service";
import Button from "../button";
import {icons} from "../icons";
import Filter from "../filter";
import {FilterMap} from "../../models/filter";
import {withDeviceIndicator} from "../../hoc/withDeviceIndicator";
import App from "../app";
import {config} from "../../config";

interface Props {
  products: QueryState;
  desktopColumnCount?: number;
  lastScrollPosition?: number;
  initialized?: boolean;
  filters: FilterMap
  isMobile: boolean;

  loadNext();

  setScrollPosition(pos: number);

  clearAllFilters();
}

interface State {
  showBackToTopArrow: boolean;
}

const mapToProps = ({products, desktopColumnCount, lastScrollPosition, initialized, filters}) => ({
  products,
  desktopColumnCount,
  lastScrollPosition,
  initialized,
  filters
});

class ListGrid extends Component<Props, State> {
  isLoading: boolean = false;
  productListElement: Node = null;
  updateScrollPos: Function = debounce(() => this.props.setScrollPosition(window.pageYOffset), 200);

  state = {
    showBackToTopArrow: false
  };

  componentDidMount(): void {
    this.productListElement = this.base.firstChild;

    window.scroll(0, this.props.lastScrollPosition);

    document.addEventListener('scroll', this.scrollListener);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.scrollListener);
  }

  isBottom(element) {
    return element.getBoundingClientRect().bottom <= window.innerHeight * 1.75;
  }

  isInViewport = (elem) => {
    const bounding = document.getElementById(elem).getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

    const vertInView = (bounding.top <= windowHeight) && ((bounding.top + bounding.height) >= 50);
    const horInView = (bounding.left <= windowWidth) && ((bounding.left + bounding.width) >= 50);

    return (vertInView && horInView);
  };

  scrolledBy(percent: number) {
    return (window.scrollY / window.innerHeight * 100) >= percent;
  }

  scrollListener = async () => {
    if (this.isLoading) {
      return;
    }

    if (this.isBottom(this.productListElement)) {
      this.isLoading = true;
      try {
        await this.props.loadNext();
      } catch (ignored) {
        // nothing more to load
      }
      this.isLoading = false;
    }

    if (this.isInViewport('filter-content')) {
      this.setState({showBackToTopArrow: false})
    } else {
      this.setState({showBackToTopArrow: true})
    }

    if (this.props.isMobile) {
      if (this.scrolledBy(100)) {
        this.setState({showBackToTopArrow: true})
      } else {
        this.setState({showBackToTopArrow: false})
      }
    }

    this.updateScrollPos();
  };

  render() {
    const hiddenContainersCount = this.props.desktopColumnCount - (this.props.products.items.length % this.props.desktopColumnCount);

    if (this.props.initialized && this.props.products.items.length <= 0 && this.props.filters.likes[0]?.selected) {
      return (
        <div class={styles['grid-container']}>
          <div class={styles['no-products']}>
            <div class={styles['info-text']}>{i18nService.translate('products_no_favorites')}</div>
            <div class={styles['filter-reset']}>
              <a href={config.url(this.props.filters.getCleanFilterUrl())}>
                <Button black={true} label={i18nService.translate('list_view_filter_reset_button')} onClickCallback={() => {}}/>
              </a>
            </div>
          </div>
        </div>
      )
    }

    if (this.props.initialized && this.props.products.items.length <= 0) {
      return (
          <div class={styles['grid-container']}>
            <div class={styles['no-products']}>
              <div class={styles['info-text']}>{i18nService.translate('product_no_product_for_filter')}</div>
              <div class={styles['filter-reset']}>
                <a href={config.url(this.props.filters.getCleanFilterUrl())}>
                  <Button black={true} label={i18nService.translate('list_view_filter_reset_button')} onClickCallback={() => {}}/>
                </a>
              </div>
            </div>
          </div>
      )
    }

    return (
        <div class={styles['grid-container']}>
          <div class={`${styles['product-list']} ${this.props.desktopColumnCount === 5 ? styles['column-count-5'] : styles['column-count-3']}`}>
            {this.props.isMobile && <div>
              {<div class={styles['bubble-filter-container']}>
                {this.props.filters.editorials.map(f => <Filter filter={f} isBubbleFilter={true} />)} </div>}
                <>{App.countryCode === "by" && <div class={styles['detail-view-hint-mobile']}>{i18nService.translate('detail_view_hint_navigation_header')}</div>}</>
                <>{App.countryCode === "hr" && <div class={styles['detail-view-hint-mobile']}>{i18nService.translate('kuna_euro_exchange_rate')}</div>}</>
            </div>}
            {this.props.products.items.map((product) => {
              // the class information is somehow lost :(
              product = new Product(product);
              return (
                  <ProductItem product={product} dimension={'List'}/>
              );
            })}

            {/*
             Fill with hidden Items to fit the item count of the last row
             Sources: https://stackoverflow.com/a/40936683, https://stackoverflow.com/a/47826868
            */}
            {Array.apply(null, {length: hiddenContainersCount}).map(() =>
                <a class={styles.hidden}/>
            )}
          </div>
          {this.state.showBackToTopArrow && <div class={styles['back-to-top']} onClick={() => window.scrollTo({left: 0, top: 0, behavior: 'smooth'})}>
            {icons.renderArrowTopIcon()}
          </div>}
        </div>
    )
  }
}

const debounce = (func: Function, delay) => {
  let debounceTimer;
  return function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      func.call(null);
    }, delay)
  }
};

export default connect(mapToProps, actions)(withDeviceIndicator(ListGrid))
